import { useRef, useState } from "react";
import { api, mediaUrl } from "../../lib/api";
import { toast } from "sonner";
import { Upload, Loader2, X, Image as ImageIcon } from "lucide-react";

export function FileUpload({ value, onChange, label, accept = "image/*", testid = "file-upload", height = "h-44" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("File caricato");
    } catch (err) {
      toast.error("Caricamento fallito");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const isVideo = accept.includes("video");

  return (
    <div data-testid={testid}>
      {label && <label className="overline mb-2 block">{label}</label>}
      <div className={`relative ${height} w-full rounded-sm border border-dashed border-[#0B1220]/25 bg-[#F4F8FF] overflow-hidden group`}>
        {value ? (
          isVideo ? (
            <video src={mediaUrl(value)} className="h-full w-full object-cover" />
          ) : (
            <img src={mediaUrl(value)} alt="preview" className="h-full w-full object-cover" />
          )
        ) : (
          <div className="h-full w-full flex flex-col items-center justify-center text-[#5C6678]">
            <ImageIcon className="h-7 w-7 mb-2" strokeWidth={1.3} />
            <span className="text-xs">Nessun file</span>
          </div>
        )}

        <div className="absolute inset-0 bg-[#0B1220]/0 group-hover:bg-[#0B1220]/30 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="bg-[#F4F8FF] text-[#0B1220] rounded-sm px-4 py-2 text-sm font-medium flex items-center gap-2"
          >
            {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            Carica
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              className="bg-[#A63C3C] text-[#F4F8FF] rounded-sm p-2"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>

        {uploading && !value && (
          <div className="absolute inset-0 flex items-center justify-center bg-[#F4F8FF]/70">
            <Loader2 className="h-6 w-6 animate-spin text-[#1452F0]" />
          </div>
        )}
      </div>

      <input ref={inputRef} type="file" accept={accept} onChange={handleFile} className="hidden" />
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="…oppure incolla un URL"
        className="editorial-input mt-2 text-sm"
      />
    </div>
  );
}
